import React, { useContext, useState } from "react";
import { passwordResetByAdmin } from "../../service/UserService";
import ModalHeader from "../Modal/ModalHeader";
import {
  DefaultButton,
  IconButton,
  PrimaryButton,
  TextField,
} from "@fluentui/react";
import themeContext from "../../context/theme/ThemeContext";
import ModalMain from "../Modal/ModalMain";
import { t } from "i18next";
import { Trans } from "react-i18next";

const PasswordResetModal = ({
  username,
  visible,
  onClose,
  fullName
}) => {
  const [step, setStep] = useState("confirm");
  const [generatedPassword, setGeneratedPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [copied, setCopied] = useState(false);
  const [errorVisible, setErrorVisible] = useState(false);

  const { getThemeColor } = useContext(themeContext);
  const handleCancel = () => {
    setGeneratedPassword("");
    setStep("confirm");
    onClose();
  };

  const generateRandomPassword = () => {
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const digits = "0123456789";
    const special = "!@#$%^&*()-_+=<>?";
    const all = upper + lower + digits + special;

    let password = "";
    password += digits[Math.floor(Math.random() * digits.length)];
    password += special[Math.floor(Math.random() * special.length)];

    for (let i = 0; i < 6; i++) {
      password += all[Math.floor(Math.random() * all.length)];
    }

    password = password
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("");
    return password;
  };

  const handleConfirm = async () => {
    setErrorMessage("");
    const generatedpassword = generateRandomPassword();

    try {
      const response = await passwordResetByAdmin(username, generatedpassword);

      if (response?.status === 200) {
        setGeneratedPassword(generatedpassword);
        setStep("copy");
      } else {
        const message = t("string-literals.failed-message");
        setErrorMessage(message);
        setErrorVisible(true);
        onClose();
      }
    } catch (error) {
      const message = t("string-literals.failed-message");
      setErrorMessage(message);
      setErrorVisible(true);
      onClose();
    }
  };

  const errorModalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={"Alert"}
        handleCancel={() => setErrorVisible(false)}
      />
    ),
    body: (
      <div style={{ padding: "3%", fontWeight: "500" }}>{errorMessage}</div>
    ),
    footer: (
      <div
        className="modal-footer-container"
        style={{
          background: getThemeColor("modal-header-footer"),
        }}
      >
        <div className="confirm-modal-footer">
          <DefaultButton
            text="Close"
            style={{ marginRight: "5px" }}
            onClick={() => setErrorVisible(false)}
          />
        </div>
      </div>
    ),
    width: "400px",
  };

  const confirmationModalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={"Alert"}
        handleCancel={handleCancel}
      />
    ),
    body: (
      <div style={{ padding: "3%", fontWeight: "600" }}>
        <div>
          <Trans
            i18nKey="string-literals.password-reset-confirmation"
            values={{ fullName }}
            components={[<strong />]}
          />
        </div>
      </div>
    ),
    footer: (
      <div
        className="modal-footer-container"
        style={{
          background: getThemeColor("modal-header-footer"),
        }}
      >
        <div className="confirm-modal-footer">
          <DefaultButton text="No" onClick={handleCancel} />
          <PrimaryButton
            style={{ margin: "0px 5px" }}
            text="Yes"
            onClick={handleConfirm}
          />
        </div>
      </div>
    ),
    width: "500px",
  };

  const copyModalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={"Alert"}
        handleCancel={handleCancel}
      />
    ),
    body: (
      <div style={{ padding: "2%", fontWeight: "500" }}>
        <div style={{ marginBottom: "10px" }}>
          <Trans
            i18nKey="string-literals.password-reset-message"
            values={{ fullName }}
            components={[<strong />]}
          />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <TextField
            readOnly
            type="password"
            value={generatedPassword}
            canRevealPassword
            styles={{ root: { flexGrow: 1, marginRight: "8px" } }}
          />
          <IconButton
            iconProps={{ iconName: "Copy" }}
            title="Copy"
            ariaLabel="Copy"
            onClick={() => {
              navigator.clipboard.writeText(generatedPassword);
              setCopied(true);
              setTimeout(() => setCopied(false), 2000);
            }}
          />
        </div>
        <p>
          {" "}
          {copied && (
            <span style={{ color: "green", marginLeft: "10px" }}>
              Password copied!
            </span>
          )}
        </p>
      </div>
    ),
    footer: (
      <div
        className="modal-footer-container"
        style={{
          background: getThemeColor("modal-header-footer"),
        }}
      >
        <div className="confirm-modal-footer">
          <DefaultButton
            text="Close"
            style={{ marginRight: "5px" }}
            onClick={handleCancel}
          />
        </div>
      </div>
    ),
    width: "500px",
  };

  if (!visible && !errorVisible) return null;

  return (
    <>
      {visible && (
        <ModalMain
          showModal={visible}
          modalDetails={
            step === "confirm" ? confirmationModalDetails : copyModalDetails
          }
        />
      )}
      {errorVisible && (
        <ModalMain showModal={errorVisible} modalDetails={errorModalDetails} />
      )}
    </>
  );
};

export default PasswordResetModal;
